import React from 'react';
import { Control, Button } from "rbx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import TextFieldMask from './TextFieldMask';

const ZipCodeField = (props) => {
  const { name, label, value, onChange, onBlur, focus=false, onClick, ...other } = props;

  return (
    <TextFieldMask 
      label={label}
      name={name}
      mask='99999-999'
      value={value}
      onChange={onChange}
      focus={focus}
      {...other}
    >
      <Control>
        <Button color="" outlined onClick={onClick} title="Clique para pesquisar o endereço pelo CEP">
          <FontAwesomeIcon icon={faSearch} />
        </Button>
      </Control>
    </TextFieldMask>
  )

}

export default ZipCodeField;
